// extracted by mini-css-extract-plugin
module.exports = {"container":"resetPassword_container__w8_WE","logo":"resetPassword_logo__226vm"};